// extracted by mini-css-extract-plugin
export default {"r_l":"_6253da46b9 d3ca46d0a9","t":"a79ba7609f"};